<template>
  <div>
    <Dialog
        :dismissableMask="true"
        :style="{ width: '35vw' }"
        :modal="true"
        :visible.sync="show"
        @hide="closeDialog"
        :contentStyle="{overflow: 'visible'}"
    >
      <template #header>
        <i style=" transform: scale(1.7);" class="pi pi-users"></i>
        <h1>הוספת תלמיד</h1>
      </template>

      <div class="p-pt-4 p-fluid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label for="firstname6">שם פרטי</label>

          <InputText type="text" v-model="newItem.firstname" autofocus/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="lastname6">שם משפחה</label>
          <InputText id="lastname6" type="text" v-model="newItem.lastname" />
        </div>

        <div class="p-field p-col-12 p-md-6">
          <label>תעודת זהות</label>
          <InputNumber
            type="decimal"
            :useGrouping="false"
            v-model="newItem.id"
          />
        </div>
<!-- grade-->
        <div class="p-field p-col-12 p-md-3">
          <label>כיתה</label>

          <Dropdown
            v-model="newItem.grade"
            :options="gradeOptions"
            placeholder="בחר כיתה"
          >
            <template #value="slotProps">
              <div v-if="slotProps.value">
                <span>{{ slotProps.value.hebrewName }}</span>
              </div>
              <span v-else>
                {{ slotProps.placeholder }}
              </span>
            </template>
            <template #option="slotProps">
              <span>{{ slotProps.option.hebrewName }}</span>
            </template>
          </Dropdown>
        </div>
      </div>

      <template #footer>
        <Button
            label="ביטול"
            icon="pi pi-times"
            @click="closeDialog"
            class="p-button-secondary"
        />
        <Button class="p-button-success" label="הוספה" icon="pi pi-check" @click="post"/>
      </template>
    </Dialog>
  </div>
</template>

<script>
import Service from "../service/Service";
import { mapState } from "vuex";

export default {
  service: null,
  props: {
    show: Boolean,
  },
  created() {
    this.service = new Service();
  },
  mounted() {
    this.setNewItwmFields();
  },
  data() {
    return {
      newItem: null,
    };
  },
  computed: {
    ...mapState(["gradeOptions"]),
  },
  methods: {
    setNewItwmFields() {
      this.newItem = {
        id: null,
        firstname: null,
        lastname: null,
        grade: null,
      };
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async post() {
      let validate = true;
      for (const key in this.newItem) {
        if (this.newItem[key] === null) {
          validate = false;
        }
      }
      // if (validate === true) {
      //   if (this.newItem.id.toString().length !== 9) {
      //     validate = false;
      //   }
      // }

      if (validate === true) {
        const gradeObj = JSON.parse(JSON.stringify(this.newItem.grade))
        const userObj = JSON.parse(JSON.stringify(this.newItem))
        userObj.grade = userObj.grade.id

        await this.service
          .post(userObj, 'pupil')
          .then(() => {
            userObj.grade = gradeObj;
            this.$emit("addItem", userObj);
            this.setNewItwmFields();
            this.openNotification(
              "success",
              `מעולה`,
              `המשתמש התתוסף במערכת`
            );

            this.closeDialog();
          })
          .catch(() => {
            this.openNotification(
              "danger",
              `אופס`,
              `אולי קיים כבר משתמש עם ת.ז. זהה`
            );
          });
      } else {
        this.openNotification(
          "danger",
          `אופס`,
          `חלק מהשדות חסרים או שגויים`
        );
      }
    },
    openNotification(color, title, text, position = "right-left", duration = 3000) {
      this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
    },
  },
};
</script>

<style >
</style>